import './styles/main.scss';

export const name = '@software-platforms/design-system-styles';
